import {
  Component,
  EventEmitter,
  inject,
  Injector,
  Input,
  Output,
  AfterViewInit,
  afterNextRender,
} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {WithdrawalAmountInputMode} from '@gatewee/utils';

@Component({
  selector: 'app-withdrawal-step-value',
  templateUrl: './withdrawal-step-value.component.html',
  standalone: false,
})
export class WithdrawalStepValueComponent implements AfterViewInit {
  private readonly injector = inject(Injector);

  @Input() form!: FormGroup;
  @Input() resolvedRecipientName = '';
  @Input() pixAmountCustomMessages: Record<string, string> = {};
  @Input() dailyRemainingHint: string | null = null;
  @Input() showHolderDocumentField = false;
  @Input() holderDocumentMask = '';
  @Input() holderDocumentMaxLength = 18;
  @Input() holderDocumentCustomMessages: Record<string, string> = {};
  @Input() amount: number | null = null;
  @Input() calculatedFee: number | null = null;
  @Input() finalAmount: number | null = null;
  @Input() amountInputMode: WithdrawalAmountInputMode = 'addFees';
  @Input() amountFieldLabelKey =
    'features.withdrawals.modalPix.amountInputMode.amountLabelRecipientReceives';
  @Input() amountFieldHint: {message: string; icon: string} = {
    message: 'features.withdrawals.modalPix.amountInputMode.fieldHintAddFees',
    icon: '@phi.info',
  };

  /** When true (fixed-amount EMV handoff), the amount field is not editable. */
  @Input() amountReadOnly = false;

  /** Taiga currency field defers paint; keep skeleton until after layout. */
  amountInputReady = false;

  @Output() readonly holderDocumentBlur = new EventEmitter<void>();
  /** Emitted after the value-step view (amount field) is mounted. */
  @Output() readonly viewReady = new EventEmitter<void>();

  ngAfterViewInit(): void {
    afterNextRender(
      () => {
        afterNextRender(
          () => {
            this.amountInputReady = true;
            this.viewReady.emit();
          },
          {injector: this.injector},
        );
      },
      {injector: this.injector},
    );
  }
}
